import { useDreamContext } from '@/store/contexts/DreamContext'

/**
 * Dream 관련 Custom Hook
 * DreamContext를 래핑하여 사용하기 편리하게 만듦
 */
export function useDream() {
  return useDreamContext()
}

